import type {ValidationResult} from 'schemaDefinition/functions/validators/types';
import type {
  CodeListMap,
  Data,
  Schema,
  SchemaModifierMap,
} from 'schemaDefinition/types';
import type {MetadataModifierKey, WorkType} from 'schemas/types';
import {MetadataModifierKeys} from 'schemas/types';
import {
  getModifiedSchema,
  getModifiedSchemaWithModifier,
} from 'schemaDefinition/functions';
import {validate} from 'schemaDefinition/functions/validators/validate';
import type {
  EntityStatus,
  GetDataBasedModifier,
  ManifestationStatus,
} from '../types';

export const validateEntity = (
  savedEntity: Data,
  entity: Data,
  relatedScope: Data,
  workType: WorkType,
  entityStatus: EntityStatus,
  baseSchema: Schema,
  getDataBasedModifier: GetDataBasedModifier | undefined,
  modifiers: SchemaModifierMap<MetadataModifierKey>,
  codelists: CodeListMap,
): {
  validation: ValidationResult;
  status: ManifestationStatus;
} => {
  const status = entityStatus.changedStatus ?? entityStatus.status;
  const dataBasedModifier = getDataBasedModifier?.(savedEntity);
  const modifiedBaseSchema = dataBasedModifier
    ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      getModifiedSchemaWithModifier(baseSchema, dataBasedModifier)
    : baseSchema;

  const modifiedSchema = getModifiedSchema(
    modifiedBaseSchema,
    modifiers,
    `${workType}.${status}`,
    MetadataModifierKeys[workType],
  );
  return {
    validation: validate(entity, relatedScope, modifiedSchema, codelists),
    status,
  };
};
